<template>
  <div v-if="user">
    <b-dropdown
      class="btn-top-navbar"
      variant="transparent"
      toggle-class="text-decoration-none"
      button-class="p-0"
      no-caret
      right
      menu-class="notification-drop-down"
      @hide="handleClick()"
    >
      <template v-slot:button-content>
        <i class="fa btn-top-navbar fa-bell"></i>
        <span class="badge badge-info ml-1" v-if="haveUnreadNotification">{{
          unreadCount
        }}</span>
      </template>
      <template v-if="haveNotification">
        <template v-for="(row, index) in lastNotifications">
          <b-dropdown-item
            class="pb-2 pt-2 notification-item"
            :key="index"
            style="min-width: 300px; max-width: 90%"
          >
            <notification-label :notification="row" />
          </b-dropdown-item>
        </template>
      </template>
      <template v-else>
        <b-dropdown-item class="pb-2 pt-2">
          Não há nenhuma nova notificação
        </b-dropdown-item>
      </template>
      <!-- <b-dropdown-divider></b-dropdown-divider> -->
      <b-dropdown-item class="pb-2 pt-2" @click="$router.push('/notificacoes')">
        <i class="fas fa-search"></i>
        Ver todas notificações
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>

import Echo from "laravel-echo";
import Pusher from "pusher-js";
import notificationLabel from "@/components/notification/sections/NotificationLabel";

export default {
  components: { notificationLabel },

  data: () => ({
    echo : null,
    lastNotifications: [],
    unreadCount: 0,
  }),

  computed: {
    user() {
      return this.$store.state.user;
    },

    haveUnreadNotification() {
      return this.unreadCount > 0; //return (this.$store.state.notifications.length > 0)
    },

    haveNotification() {
      return this.lastNotifications.length > 0;
    },
  },

  mounted() {
    this.echo = new Echo({
      broadcaster: "pusher",
      key: "39f7df1d357662de9f39",
      cluster: "mt1",
      forceTLS: true,
    });

    this.getLastNotifications();

    this.setNotificationListener();
  },

  methods: {
    async getLastNotifications() {
      let data = await this.$store.dispatch(
        "notification/getLastNotifications"
      );

      this.lastNotifications = data.notifications;
      this.unreadCount = data.unreadCount;
    },

    handleClick() {
      this.unreadCount = 0;
      this.$store.dispatch("notification/markAsRead");
    },

    setNotificationListener() {
      this.echo.private(`user.${this.user.id}`).notification(async (notification) => {
        await new Promise(resolve => setTimeout(resolve, 2000))
        this.getLastNotifications();
      });
    },
  },
};
</script>
<style>
.badge-notification {
  position: relative;
  margin-left: -20%;
  margin-top: -50%;
}

.notification-drop-down {
  padding: 0px !important;
}

.notification-item {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.notification-success {
  border-left: 4px solid #8bc34a;
}

.notification-info {
  border-left: 4px solid #17a2b8;
}

.notification-warning {
  border-left: 4px solid #17a2b8;
}

.notification-danger {
  border-left: 4px solid #dc3545;
}
</style>